import React, { useState, useEffect } from "react";
import { CardText, Table } from "reactstrap";
import "assets/scss/website/app.scss";
import "react-rangeslider/lib/index.css";
import { useSelector, useDispatch } from "react-redux";
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";
import { addInterest } from "store/Auth/actions";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import ProfileService from "services/Website/ProfileService";
import TableList from "./TableList";
const ManageAppointment = ({ appointments, history }) => {
	const { t } = useTranslation();
	const [Interested, setInterested] = useState(false);

	const [appoinmentData, setAppoinmentdata] = useState([]);
	const profileService = new ProfileService();
	const AuthData = useSelector((state) => state.Auth);
	const dispatch = useDispatch();
	const isInterested = (id) => {
		return AuthData.interestsUnits.includes(id);
	};

	useEffect(() => {
		profileService?.getAppoinment().then((response) => {
			if (response && response.status === SuccessOk) {
				setAppoinmentdata([...response.data]);
			}
		});
	}, []);

	return (
		<div className="websitPages tab-details px-md-5 py-md-5 px-3 py-4">
			<h3
				className="text-primary fw-bold font-size-26"
				dangerouslySetInnerHTML={{
					__html: t("Manage Appointments Title"),
				}}></h3>
			<div>
				<div dir={AuthData.lang !== "ar" ? "ltr" : "rtl"}>
					<div className="table-responsive tableMinWidth">
						<Table className="mt-4 mb-0">
							<thead>
								<tr>
									<th
										className={classnames("", {
											"text-end": AuthData.lang === "ar",
											"text-start": AuthData.lang !== "ar",
										})}>
										{t("Title")}
									</th>
									{/* <th
										className={classnames("", {
											"text-end": AuthData.lang === "ar",
											"text-start": AuthData.lang !== "ar",
										})}>
										{t("Sales Rep")}
									</th> */}
									<th
										className={classnames("", {
											"text-end": AuthData.lang === "ar",
											"text-start": AuthData.lang !== "ar",
										})}>
										{t("Property")}
									</th>
									<th
										className={classnames("", {
											"text-end": AuthData.lang === "ar",
											"text-start": AuthData.lang !== "ar",
										})}>
										{t("Type")}
									</th>
									<th
										className={classnames("", {
											"text-end": AuthData.lang === "ar",
											"text-start": AuthData.lang !== "ar",
										})}>
										{t("Date")}
									</th>
									<th
										className={classnames("", {
											"text-end": AuthData.lang === "ar",
											"text-start": AuthData.lang !== "ar",
										})}>
										{t("Status")}
									</th>
								</tr>
							</thead>
							<tbody>
								{appoinmentData
									// ?.filter((item) => item.status === "Upcoming")
									?.map((appointment, index) => {
										return (
											<TableList
												key={index}
												appointment={appointment}
												history={history}
											/>
										);
									})}
							</tbody>
						</Table>
					</div>
				</div>
			</div>
		</div>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};
export default ManageAppointment;
